import React, { useState, useRef, useEffect, useContext } from "react";
// import { Link } from "react-router-dom";
import axios from "axios";
import Menu from "../../components/menu/Menu";
import Workouts from "../../components/workouts/Workouts";
import { Context } from "../../context/Context";

const WorkoutsDash = (props) => {

  const {workoutsData, setWorkoutsData, contentWorkoutsLoaded, setContentWorkoutsLoaded} = useContext(Context);

  // const [workoutsData, setWorkoutsData] = useState([]);
  const [search, setSearch] = useState("");
  const searchProgs = useRef("");
  const [isSorted, setSorted] = useState(true);
  // const [contentWorkoutsLoaded, setContentWorkoutsLoaded] = useState(false);
  // eslint-disable-next-line
  const [modalOpened, setModalOpened] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [homeExerciseDeleteId, setHomeExerciseDeleteId] = useState(0);
  const [succPopUp, setSuccPopUp] = useState(false);

  useEffect(() => {
    localStorage.removeItem("disableUnLoad");
    localStorage.removeItem("ExerBuilderEdited");
  }, [])

  useEffect(() => {
    props.actSidebar(true);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      localStorage.removeItem("workout_templateId");
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "tasks/get-all-workouts", {
          search,
        })
        .then((res) => {
          if (res.data.responseData) {
            setWorkoutsData(res.data.responseData);
            setContentWorkoutsLoaded(true);
            if (JSON.parse(localStorage.getItem("updateWorkouts")) !== null) {
              setSuccPopUp("PT Session updated successfully.");
              localStorage.removeItem("updateWorkouts");
            }
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
            props.checkLoggedIn(false);
          }
        });
    }
  }, [props, search]);

  const updateSearchQuery = (value) => {
    // setContentWorkoutsLoaded(false)
    if (value && value.length >= 3) {
      setSearch(value);
    } else if (value === "") {
      setSearch("");
    }
  };
  const updateHomeExerciseData = (data) => {
    setWorkoutsData(data);
  };
  const dropDown = (i) => {
    const mod = [...workoutsData];
    for (let m of mod) {
      m.modalOpened = false;
    }
    let toggle = mod[i].modalOpened;
    mod[i].modalOpened = !toggle;
    setWorkoutsData(mod);
  };
  const closeDeleteModal = () => {
    setModalVisible(false);
  };
  const handleDeleteModal = (id) => {
    setModalVisible(true);
    const mod = [...workoutsData];
    for (let m of mod) {
      m.modalOpened = false;
    }
    setWorkoutsData(mod);
    setHomeExerciseDeleteId(id);
  };

  const handleDeleteHomeExercise = () => {
    setContentWorkoutsLoaded(false);
    setModalVisible(false);
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/delete-home-exercise-data", { homeExerciseDeleteId })
      .then((res) => {
        if (res.data.responseData) {
          setContentWorkoutsLoaded(true);
          setModalVisible(false);
          setWorkoutsData(res.data.responseData);
          setSuccPopUp("PT Session has been deleted successfuly!");
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
          props.checkLoggedIn(false);
        }
      });
  };

  const handleSorting = (column, array) => {
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setWorkoutsData(sorted);
  };

  const popupRef = useRef(succPopUp);
  useEffect(() => {
    popupRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp(false);
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);
  return (
    <div>
      <Menu title={"PT Session"} />
      <div className="programs_dash_hold">

        <div className="table_component_container" style={{paddingTop: '10px'}}>
        <Workouts
          workoutsData={workoutsData}
          searchProgs={searchProgs}
          updateSearchQuery={updateSearchQuery}
          handleSorting={handleSorting}
          contentLoaded={contentWorkoutsLoaded}
          modalOpened={modalOpened}
          dropDown={dropDown}
          handleDeleteModal={handleDeleteModal}
          updateHomeExerciseData={updateHomeExerciseData}
          modalVisible={modalVisible}
          closeDeleteModal={closeDeleteModal}
          handleDeleteHomeExercise={handleDeleteHomeExercise}
        />
        </div>
        {succPopUp && (
          <div className="prog_err_hold prog_pop_pat_correct">
            <div className="prog_pop_icon_correct prog_err_icon"></div>
            <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkoutsDash;
